<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    style="width:500px;margin:auto;"
    @close="close"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" v-loading="loading" :element-loading-text="elementLoadingText">
      <div class="selectSpec">
        <div class="searchtree-item" v-for="(item,i) in form.frontendPropertyInfo"  :key="i">
              <div class="searchtree-label">{{item.name}}：</div>
              <ul style="flex-wrap:wrap">
                  <li  v-for="(p,j) in item.propertyDetails"  :key="j" :class='["item",p.current ? "on" : ""]' @click="selAttr(i,j)">
                      {{p.name}}
                   </li>       
              </ul>
         </div>
         <div class="searchtree-item">
              <div class="searchtree-label-num">数量：</div>
              <ul style="flex-wrap:wrap">
                  <li class="num">
                      <span class="reduceNum no-select" @click="reduceNum">
                        -
                      </span>
                      <input type="text" v-model="num" :disabled="stockNum<=0" @change="changeNum" >
                      <span class="addNum no-select" @click="addNum">
                        +
                      </span>  
                      <span class="no-select">库存剩余({{stockNum}})</span>
                   </li>       
              </ul>
         </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">加入购物车</el-button>
    </div>
  </el-dialog>
</template>
<style>
@import '../../../styles/selectSpec.css';
</style>
<script>
  import {mapGetters, mapActions,mapMutations,mapState} from 'vuex'
export default {
  name: 'SelectSpec',
  components: { },
  data() {
    return {
      num:1,
      stockNum:1,
      helpFund:0.00,
      selectIndexArray:[],
      form: { },
      rules: { },     
      title: '',
      elementLoadingText: '数据上传中，请稍后...',     
      loading:false,
      dialogFormVisible: false,
    }
  },
  computed: {
      ...mapState(['isLogined'])
    },
  created() {},
  methods: {
    ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
    async showSelect(row) {
      this.title = '选择规格'       
      this.form = row 
      this.helpFund = row.helpFund   
      this.num=1;
      this.stockNum=1;
      this.dialogFormVisible = true
    },    
    checkAttr(){
      var productSpecs = this.form.productSpecs; //原始规格数据
      //判断是否所以规格组都选中
      var frontendPropertyInfo = this.form.frontendPropertyInfo;
      var tips = ''
      var selectAttrid = []

      for (var i = 0; i < frontendPropertyInfo.length; i++) {
        if (this.selectIndexArray.indexOf(i) < 0) {
          tips = '请选择' + frontendPropertyInfo[i].name
        }
        var propertyDetails = frontendPropertyInfo[i].propertyDetails;
        for (var j = 0; j < propertyDetails.length; j++) {
          if (propertyDetails[j].current) {
              selectAttrid.push(propertyDetails[j].id)
          }
        }
      }
      if (tips) {
        this.$message({ message: tips, type: 'error', customClass: 'c-msg' }) 
        return false
      }

      var specId = productSpecs[0].id;
      //从原始数据中找到相应规格组
      for (var i = 0; i < productSpecs.length; i++) {
        var tmp = []
        for (var y = 0; y < productSpecs[i].productPropertyInfo.length; y++) {
          tmp.push(productSpecs[i].productPropertyInfo[y].vid);
        }
        if (tmp.sort().toString() == selectAttrid.sort().toString()) {
          specId = productSpecs[i].id //规格id
          if (productSpecs[i].quantity <= 0) {
            this.$message({ message: '该规格库存不足', type: 'error', customClass: 'c-msg' }) 
            return;
          }
        }
      }
      if (specId == 0) {
        this.$message({ message: '请选择规格', type: 'error', customClass: 'c-msg' }) 
        return false
      }
      return specId 
    },
    selAttr (index,jj) {
        var count = this.form.frontendPropertyInfo[index].propertyDetails.length;

        for (var i = 0; i < count; i++) {
            this.form.frontendPropertyInfo[index].propertyDetails[i].current = false;
        }
        this.form.frontendPropertyInfo[index].propertyDetails[jj].current =true


        var selectIndexArray = this.selectIndexArray
        if (selectIndexArray.indexOf(index) < 0) {
            selectIndexArray.push(index)
        }
        var selectAttrid = []
        for (var i = 0; i < this.form.frontendPropertyInfo.length; i++) {
            var propertyDetails = this.form.frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                }
            }
        }
        var product = this.form

        var stockNum = this.stockNum   

        for (var i = 0; i < product.productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                stockNum = product.productSpecs[i].quantity
            }
        }
        this.stockNum = stockNum
        if(this.num>this.stockNum)this.num=this.stockNum;
        this.selectIndexArray = selectIndexArray
        this.$forceUpdate();
      },
      reduceNum()
      {
        this.num--;
        if(this.num<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
      },
      addNum()
      {
         this.num++;
        if(this.num>this.stockNum)
        {
          this.$message({ message: '数量不可大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=this.stockNum;
          return;
        }
      },
    changeNum()
    {      
      var myreg=/^\+?[1-9]\d*$/;
        if(!myreg.test(this.num))
        {
          this.$message({ message: '数量格式不对', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
      if(this.num==''||this.num==undefined|| parseInt(this.num)>this.stockNum)
        {
          this.$message({ message: '数量不可为空，且不得大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
        if(parseInt(this.num)<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
    },
    close() {
      this.dialogFormVisible = false
    },
    save(){
        if(!this.isLogined)
        {
          this.$router.push({ name: 'userLogin' })
          return;
        }
        if(this.num<=0)
        {
          this.$message({ message: '请输入要购买的数量', type: 'error', customClass: 'c-msg' }) 
          return;
        }
        let specId= this.checkAttr()
         if(!specId){
           return
         }
        let specName = ''
        this.form.productSpecs.forEach((item) => {
          if (item.id === specId){
            specName = item.specName
          }
        })
         
        this.addCart(this.form.id, this.form.settlementPrice, this.form.name, this.form.defaultImage, specId, specName,this.num)
      },
      addCart (id, price, name, img, specId, specName,num) {
         this.ADD_CART({
            productId: id,
            settlementPrice: price,
            name: name,
            defaultImage: img,
            num: num,
            specId: specId,
            specName:specName,
            helpFund:this.helpFund
          })
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          let imgs= "http://localhost:8888/static/images/logo.png"
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: imgs})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
          this.$message({ message: '加入购物车成功', type: 'success', customClass: 'c-msg' }) 
          this.dialogFormVisible = false
      }
  },
}
</script>



// WEBPACK FOOTER //
// SelectSpec.vue?48b6c15d